import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
const forEach = require('lodash/forEach');
const find = require('lodash/find');

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
const GlobalUserActions = require('../../actions/GlobalUserActions');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    user: PropTypes.object.isRequired,
    onUpdateAccountType: PropTypes.func.isRequired,
}

const defaultProps = {};

class AdminUserPlanSelector extends React.Component {
    constructor(props) {
        super(props);

        this.getStateFromPlanStoreState = this.getStateFromPlanStoreState.bind(this);
        const planState = this.getStateFromPlanStoreState(SubscriptionPlanStore.getState(), props.user);

        this.state = {
            subscriptionPlanStoreState: SubscriptionPlanStore.getState(),
            user_update_action: null,
            ...planState,
            currentPlan: planState.currentPlan,
            selected_plan_id: planState.selected_plan_id
        };

        this.getStateFromPlanStoreState = this.getStateFromPlanStoreState.bind(this);
        this.changeUserPlan = this.changeUserPlan.bind(this);
        this.unsubscribes = [
            SubscriptionPlanStore.listen(this.onSubscriptionPlanStoreChange.bind(this))
        ];
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user.id === this.props.user.id) {
            return;
        }

        const planState = this.getStateFromPlanStoreState(SubscriptionPlanStore.getState(), this.props.user);
        this.setState({ // eslint-disable-line  @eslint-react/no-set-state-in-component-did-update
            plan_error: null,
            ...planState,
            currentPlan: planState.currentPlan,
            selected_plan_id: planState.selected_plan_id,
        });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSubscriptionPlanStoreChange(state) {
        const s = this.getStateFromPlanStoreState(state, this.props.user);
        if (this.state.user_update_action) {
            s.user_update_action = null;
            GlobalUserActions.getAuthors(uuid.v4()); // request new users in case something changed
        }

        return this.setState(s);
    }

    getStateFromPlanStoreState(storeState, selectedUser) {
        let author_plans = [];
        let selected_plan_id = '';
        let currentPlan = null;
        const selected_user_id = selectedUser ? selectedUser.id : '';

        forEach(storeState.plans, plan => {
            if (selected_user_id && plan.users) {
                const u = find(plan.users,{user_id: selected_user_id});
                if (u) {
                    currentPlan = plan;
                    selected_plan_id = plan.id;
                }
            }

            if ((plan.process_type === Globals.ecommerce.process_types.PO) && (Globals.users.is_user_account_type(plan.account_type))) {
                author_plans.push(plan);
            }
        });

        return {
            author_plans: author_plans,
            selected_plan_id: selected_plan_id,
            currentPlan: currentPlan
        };
    }

    changeUserPlan(new_plan_id) {
        this.setState({plan_error: null});
        if (this.state.selected_plan_id === new_plan_id) {
            console.log("changeUserPlan: no change.");
            return;
        }
        // this.setState({selected_plan_id: new_plan_id});

        const self = this;
        if (confirm("Are you sure you want to change this user's plan?")) {
            const actionId = uuid.v4();
            this.setState({ user_update_action: actionId }, () => {
                SubscriptionPlanActions.changePurchaseOrderPlan(actionId, this.props.user.id, new_plan_id);
            });      
        }

    }

    render() {
        if (!this.state.author_plans || !this.state.author_plans.length ) {
            return null;
        }

        if (!this.props.user) {
            return null;
        }

        if (this.props.user.type !== Globals.users.type.LOCAL) {
            return (
                <div>
                    Unavailable for this user type.
                </div>
            );
        }

        if (this.state.currentPlan && this.state.currentPlan.process_type === Globals.ecommerce.process_types.CC) {
            return (
                <div className="org-plan-readonly">
                    <label>Subscription Plan:</label>
                    <span>{this.state.currentPlan.display_name}</span>
                </div>
            )
        }

        // console.log("renderOrgPlanChooser selectedUser: " + JSON.stringify(this.state.selectedUser)); // TODO: check account_type and/or selected_plan_id.  Don't allow changing CC types (only PO types) ?

        const self = this;
        let selectedPlan; // = find(this.state.author_plans,{id: this.state.org_plan_id});
        const planMenuItems = this.state.author_plans.map((plan) => {
            let itemClass = 'AriaMenuButton-menuItem';
            if(self.state.selected_plan_id === plan.id) {
                itemClass += ' is-selected';
                selectedPlan = plan;
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={plan.id}>
                    <MenuItem
                        className={itemClass}
                        value={plan.id}
                        text={plan.display_name}
                    >
                        {plan.display_name}
                    </MenuItem>
                </li>
            );
        });

        const changeableAccountTypes = [Globals.users.account_types.FREE, Globals.users.account_types.FREE_V2];

        return  (
            <div className="org-plan-chooser">
                <label htmlFor="plan-interval">Subscription Plan</label>
                <Wrapper id="plan-interval" className='AriaMenuButton margin-left-sm' onSelection={this.changeUserPlan}>
                    <Button className='AriaMenuButton-trigger'>
                        {selectedPlan ? selectedPlan.display_name : 'select a plan'}
                    </Button>
                    <Menu>
                        <ul className='AriaMenuButton-menu'>
                            {planMenuItems}
                        </ul>
                    </Menu>
                </Wrapper>
                {(!selectedPlan && changeableAccountTypes.indexOf(this.props.user.account_type) >=0) &&
                    <div className="margin-top-md">
                        <label htmlFor="account-type-chooser">Account Type</label>
                        <Wrapper
                            id="account-type-chooser"
                            className='AriaMenuButton margin-left-sm'
                            onSelection={this.props.onUpdateAccountType}
                        >
                            <Button className='AriaMenuButton-trigger'>
                                {StringUtil.getStingForAccountTypeAdmin(this.props.user.account_type)}
                            </Button>
                            <Menu>
                                <ul className='AriaMenuButton-menu'>
                                    {changeableAccountTypes.map((atToken) => {
                                        return (
                                            <li className='AriaMenuButton-menuItemWrapper' key={atToken}>
                                                <MenuItem
                                                    className={`AriaMenuButton-menuItem${atToken === self.props.user.account_type ? ' is-selected' : ''}`}
                                                    value={atToken}
                                                    text={StringUtil.getStingForAccountTypeAdmin(atToken)}
                                                >
                                                    {StringUtil.getStingForAccountTypeAdmin(atToken)}
                                                </MenuItem>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Menu>
                        </Wrapper>
                    </div>
                }
                <ErrorBox error={self.state.plan_error}/>
            </div>
        );
    }
}

AdminUserPlanSelector.propTypes = propTypes;
AdminUserPlanSelector.defaultProps = defaultProps;

export default AdminUserPlanSelector;